import { connect } from "react-redux";
import CaptionDialog from "components/Captions/CaptionDialog";
import getUseCaptionDialog from "selectors/breakpoint/getUseCaptionDialog";
import getTextTrackLanguages from "selectors/captions/getTextTrackLanguages";
import {
  setCaptionsSelectionMenuVisibility,
  setTextTrackLanguage,
  showTextTrackCaptionSettings,
} from "actions/CaptionActions";

const mapStateToProps = (state, ownProps) => ({
  showing:
    state.captions.showCaptionsSelectionMenu &&
    getUseCaptionDialog(state, ownProps),
  textTrackLanguage: state.captions.textTrackLanguage,
  textTracks: getTextTrackLanguages(state, ownProps),
});

const mapDispatchToProps = (dispatch) => ({
  onCloseClick: () => dispatch(setCaptionsSelectionMenuVisibility(false)),
  onSetTextTrackLanguage: (lang) => dispatch(setTextTrackLanguage(lang)),
  onShowTextTrackCaptionSettings: () =>
    dispatch(showTextTrackCaptionSettings()),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(CaptionDialog);
